module.exports = __webpack_public_path__ + "static/media/PDF5.e4ed305a.pdf";